import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListSellers from './ListSellers';
import SellerEdit from './SellerEdit';
import SellerNew from './SellerNew';
import SelectTipoPublicaciones from './TipoPublicaciones/SelectTipoPublicaciones';
import GestionDatosBancarios from './GestionDatosBancarios';

export default class AdmSellers extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListSellers />} />
                    <Route path="Editar/:id" element={<SellerEdit />} />
                    <Route path="Editar/Select/:id" element={<SellerEdit />} />
                    <Route path="Nuevo" element={<SellerNew />} />
                    <Route path="TiposPublicaciones/Select" element={<SelectTipoPublicaciones />} />
                    <Route path="Nuevo/Select" element={<SellerNew />} />
                    <Route path="GestionDatosBancarios" element={<GestionDatosBancarios />} />
                </Routes>
            </div>
        );
    }
}